import { AxiosInstance } from 'axios';
import SMSRepositoryInterface, {
  ApiCreateSmsTemplateInterface,
  SmsTemplateInterface,
} from '@/services/SMS/interfaces';
import { SmsEntityInterface, SmsInterface } from '@/services/SMS/interfaces/sms.interfaces';

export default class SMSRepository implements SMSRepositoryInterface{
  constructor(
    private axios: AxiosInstance
  ) {
  }


  public async createTemplate(data: ApiCreateSmsTemplateInterface) {
    const res = await this.axios.post('/sms/templates',data)
    return res.data
  }

  public async createSMS(data: SmsInterface): Promise<void> {
    const res = await this.axios.post('/sms/messages',data)
    return res.data
  }

  public async getAllTemplates(): Promise<SmsTemplateInterface[]> {
    const res = await this.axios.get('/sms/templates')
    return res.data
  }

  public async deleteTemplateByName(templateName:string): Promise<void> {
    await this.axios.delete(`/sms/templates/${templateName}`)
  }

  public async getAllSms(): Promise<SmsEntityInterface[]> {
    const res = await this.axios.get('/sms/messages')
    return res.data[0]
  }

  public async loadTemplates(): Promise<SmsTemplateInterface[]> {
    const res = await this.axios.get('/sms/templates')
    return res.data
  }

  public async getTemplate(selectedType:string): Promise<SmsTemplateInterface> {
   const res =  await this.axios.get(`/sms/templates/${selectedType}`)
    return  res.data
  }

  public async updateTemplate(id: number,updateTemplateDto: Omit<SmsTemplateInterface, "id">): Promise<SmsTemplateInterface> {
    const res = await this.axios.patch(`/sms/templates/${id}`,updateTemplateDto)
    return res.data
  }
}
